import { FC, PropsWithChildren } from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type FieldTitleTooltipWrapperIwProps = PropsWithChildren & { tooltip: string };

export const FieldTitleTooltipWrapperIw: FC<FieldTitleTooltipWrapperIwProps> = ({
  children,
  tooltip,
}) => {
  return (
    <TitleWithTooltipWrapper>
      {children}

      <Tooltip
        overlayStyle={{ maxWidth: 500, padding: 0 }}
        placement="top"
        title={<TooltipContainer>{tooltip}</TooltipContainer>}
        color={COLORS.white}
      >
        <div />
        <Icon name="info" size="s20" />
      </Tooltip>
    </TitleWithTooltipWrapper>
  );
};

const TitleWithTooltipWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TooltipContainer = styled.div`
  color: ${COLORS.systemDark300};
  padding: 6px;
  white-space: nowrap;
`;
